import { render } from "./Conversation.vue?vue&type=template&id=669c58c6&scoped=true"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"

import "./Conversation.vue?vue&type=style&index=0&id=669c58c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-669c58c6"

export default script